<template>
  <a-dialog v-model="show" persistent max-width="850px" scrollable>
    <v-card class="d-flex">
      <v-toolbar color="primaryLight1" height="40px">
        <v-btn icon large>
          <v-icon v-if="!isEdit">mdi-account-plus</v-icon>
          <v-icon v-if="isEdit">mdi-account-edit</v-icon>
        </v-btn>
        <span>{{ $t("admin.lblUserSettings") }}</span>
        <v-spacer></v-spacer>
        <CloseIcon @click="close()" />
      </v-toolbar>

      <v-card-text id="dialog-card-text">
        <v-form
          ref="refUserForm"
          v-model="valid"
          lazy-validation
          autocomplete="off"
        >
          <v-container class="ma-0">
            <v-row>
              <v-col cols="12" sm="12" md="12" class="mb-0 pb-0">
                <v-combobox
                  :disabled="!isPhotoUploading"
                  v-model="selectedEmail"
                  :items="peoples"
                  :filter="filter"
                  :search-input.sync="resultSearch"
                  :rules="emailRules"
                  required
                  ref="combobox"
                  class="searchComboBox"
                  id="searchComboBox"
                  :label="`${$t('admin.lblSelectEmail')} *`"
                  :placeholder="`${$t('admin.lblSelectEmail')} *`"
                  item-color="#f4f4f4"
                  single-line
                  dense
                  :clearable="!isEdit"
                  filled
                  @input="resultSearch = null"
                  item-text="email"
                  item-value="id"
                  return-object
                  :readonly="isEdit"
                  :autocomplete="comboboxAutoSuggest"
                  @focus="focusEmail"
                  @blur="comboboxAutoSuggest = 'none'"
                >
                  <template v-slot:selection="data">
                    <v-list-item
                      dense
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      :disabled="data.disabled"
                      @click:close="data.parent.selectItem(data.item)"
                      class="userListItem"
                    >
                      <v-list-item-avatar class="mt-0 mb-0 mr-2" size="40">
                        <v-img
                          v-if="data.item.profilePhoto"
                          contain
                          :src="data.item.profilePhoto"
                        ></v-img>
                        <v-img
                          v-else
                          contain
                          src="@/assets/images/NoPhotoIcon.png"
                        ></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-if="data.item.firstName">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs" v-on="on" >
                              {{ data.item.firstName + " " + data.item.lastName }}
                              <br />
                              {{
                                data.item.registered_email
                                  ? data.item.registered_email
                                  : data.item.display_email
                              }}
                              </span>
                            </template>
                          <span >
                            {{ data.item.firstName + " " + data.item.lastName }}
                            <br />
                            {{
                              data.item.registered_email
                                ? data.item.registered_email
                                : data.item.display_email
                            }}
                          </span>
                        </v-tooltip>
                        </v-list-item-title>
                        <v-list-item-title v-else-if="data.item.display_email || data.item.registered_email">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs" v-on="on" >
                              {{
                                  data.item.registered_email
                                    ? data.item.registered_email
                                    : data.item.display_email
                                }}
                              </span>
                            </template>
                          <span >
                            {{
                              data.item.registered_email
                                ? data.item.registered_email
                                : data.item.display_email
                            }}
                          </span>
                        </v-tooltip>
                           
                        </v-list-item-title>
                        <v-list-item-title v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs" v-on="on" >
                              {{ data.item }}
                              </span>
                            </template>
                          <span>
                            {{ data.item }}
                          </span>
                        </v-tooltip>
                      </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action style="flex-direction: inherit">
                        <v-btn
                          outlined
                          x-small
                          color="primaryDark"
                          class="mr-2"
                          v-if="data.item.is_listed_in_people === true"
                        >
                          {{ $t("admin.lblListedInPeople") }}
                        </v-btn>
                        <v-btn
                          outlined
                          x-small
                          color="primaryDark"
                          v-if="
                            data.item.is_registered_user === true &&
                            data.item.registered_email
                          "
                        >
                          {{ $t("admin.lblRegistered") }}
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list color="#FFF" class="combo-list ma-0 pa-0">
                      <v-list-item
                        v-if="
                          item.contactEmailIds &&
                          item.contactEmailIds.length <= 1
                        "
                        :class="[
                          itemSelected(item.registered_email)
                            ? 'selected-removed'
                            : '',
                        ]"
                      >
                        <v-list-item-avatar class="mt-0 mb-0 mr-2" size="40">
                          <v-img
                            v-if="item.profilePhoto"
                            contain
                            :src="item.profilePhoto"
                          ></v-img>
                          <v-img
                            v-else
                            contain
                            src="@/assets/images/NoPhotoIcon.png"
                          ></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            <label>
                              <span v-if="item.firstName">
                                {{ item.firstName + " " + item.lastName }}
                              </span>
                              <span v-else>{{
                                item.display_email
                                  ? item.display_email
                                  : item.registered_email
                              }}</span>
                            </label>
                          </v-list-item-title>
                          <v-list-item-subtitle v-if="item.firstName">
                            <label>
                              {{
                                item.display_email
                                  ? item.display_email
                                  : item.registered_email
                              }}
                            </label>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action style="flex-direction: inherit">
                          <v-btn
                            outlined
                            x-small
                            color="primaryDark"
                            class="mr-2"
                            v-if="item.is_listed_in_people === true"
                          >
                            {{ $t("admin.lblListedInPeople") }}
                          </v-btn>
                          <v-btn
                            outlined
                            x-small
                            color="primaryDark"
                            v-if="item.is_registered_user === true"
                          >
                            {{ $t("admin.lblRegistered") }}
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                      <v-list-group
                        v-else
                        v-model="item.active"
                        no-action
                        class="bg-divider"
                        :class="[
                          itemSelectedGroup(item.id) ? 'selected-removed' : '',
                        ]"
                        @click.stop.prevent=""
                      >
                        <template v-slot:activator>
                          <v-list-item-avatar class="mt-0 mb-0 mr-2" size="40">
                            <v-img
                              v-if="item.profilePhoto"
                              contain
                              :src="item.profilePhoto"
                            ></v-img>
                            <v-img
                              v-else
                              contain
                              src="@/assets/images/NoPhotoIcon.png"
                            ></v-img>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              <label>
                                <span v-if="item.firstName">
                                  {{ item.firstName + " " + item.lastName }}
                                </span>
                                <span v-else>{{
                                  item.display_email
                                    ? item.display_email
                                    : item.registered_email
                                }}</span>
                              </label>
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="item.firstName">
                              <label>
                                {{
                                  item.display_email
                                    ? item.display_email
                                    : item.registered_email
                                }}
                              </label>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action style="flex-direction: inherit">
                            <v-btn
                              outlined
                              x-small
                              color="primaryDark"
                              class="mr-2"
                              v-if="
                                item.is_listed_in_people === true &&
                                item.display_email
                              "
                            >
                              {{ $t("admin.lblListedInPeople") }}
                            </v-btn>
                            <v-btn
                              outlined
                              x-small
                              color="primaryDark"
                              v-if="
                                item.is_registered_user === true &&
                                item.registered_email
                              "
                            >
                              {{ $t("admin.lblRegistered") }}
                            </v-btn>
                          </v-list-item-action>
                        </template>
                        <template>
                          <v-divider></v-divider>
                          <v-subheader
                            v-if="
                              item.contactEmailIds &&
                              item.contactEmailIds.length > 0
                            "
                            class="text-subtitle-2 mt-2 mb-0 pt-0 pb-0"
                            color="black"
                            style="height: 25px"
                            >{{ $t("admin.lblContactEmailList") }}:</v-subheader
                          >
                          <v-list-item
                            v-for="contactEmail in item.contactEmailIds"
                            :key="`email-${contactEmail}-${uniqueKey()}-child`"
                            @click.stop="selectEmail(item.id, contactEmail)"
                            :class="[
                              itemSelected(contactEmail)
                                ? 'selected-removed'
                                : '',
                            ]"
                          >
                            <v-list-item-content>
                              <label>
                                <span>{{ contactEmail }}</span>
                              </label>
                            </v-list-item-content>
                            <v-list-item-action style="flex-direction: inherit">
                              <v-btn
                                outlined
                                x-small
                                color="primaryDark"
                                class="mr-2"
                                v-if="
                                  item.is_listed_in_people === true &&
                                  item.display_email == contactEmail
                                "
                              >
                                {{ $t("admin.lblListedInPeople") }}
                              </v-btn>
                              <v-btn
                                outlined
                                x-small
                                color="primaryDark"
                                v-if="
                                  item.is_registered_user === true &&
                                  item.registered_email == contactEmail
                                "
                              >
                                {{ $t("admin.lblRegistered") }}
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                          <v-divider></v-divider>
                        </template>
                      </v-list-group>
                    </v-list>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" sm="3" class="pt-0 pb-2">
                <v-card flat>
                  <profile-photo
                    @uploading="photoUploading"
                    v-model="userForm.profilePhoto"
                    section="user"
                  ></profile-photo>
                </v-card>
              </v-col>
              <v-col cols="9" sm="9" class="pt-2 pb-2">
                <v-row>
                  <v-col cols="12" sm="12" class="pt-2 pb-2">
                    <a-text-field
                      :disabled="!isPhotoUploading"
                      class="textField"
                      filled
                      v-model.trim="userForm.firstName"
                      :requiredMessage="$t('firstNameMandatory')"
                      required
                      :label="`${$t('admin.lblFirstName')}`"
                      :readonly="isReadonly"
                      @keydown="filterKey"
                      :autocomplete="fNameAutoSuggest"
                      @focus="fNameAutoSuggest = 'on'"
                      @blur="fNameAutoSuggest = 'none'"
                    ></a-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" class="pt-2 pb-2">
                    <a-text-field
                      :disabled="!isPhotoUploading"
                      class="textField"
                      v-model="userForm.lastName"
                      :label="$t('admin.lblLastName')"
                      :requiredMessage="$t('lastNameMandatory')"
                      required
                      filled
                      :readonly="isReadonly"
                      @keydown="filterKey"
                      :autocomplete="lNameAutoSuggest"
                      @focus="lNameAutoSuggest = 'on'"
                      @blur="lNameAutoSuggest = 'none'"
                    ></a-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" class="pt-2 pb-2">
                <repeat-email-input
                  v-model="userForm.contactEmailIds"
                  :mainEmail="userForm.registered_email"
                  :userEmails="usersWithContactEmails"
                  :userId="data ? data.id : null"
                  :readonly="isReadonly"
                  :emailsInAttendees="data.emails_in_attendees"
                  @newFieldAdded="newEmailAdded"
                  :isPhotoUploading="isPhotoUploading"
                  @isTypingEmail="onTypingEmail"
                ></repeat-email-input>
              </v-col>
              <v-col cols="12" sm="12" class="pt-2 pb-2">
                <v-autocomplete
                  :disabled="!isPhotoUploading"
                  id="userRoleId"
                  multiple
                  v-model.trim="userForm.roles"
                  :items="roleListItems"
                  item-text="role"
                  item-value="id"
                  :label="`${$t('admin.lblGeneralRole')}*`"
                  :no-data-text="$t('noData')"
                  :rules="roleRules"
                  required
                  chips
                  :search-input.sync="search"
                  @change="changeSkills"
                  filled
                  dense
                  @focus="focusRoles"
                  ref="refRoles"
                  :readonly="isReadonly"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col cols="12" sm="12" class="pt-0 pb-2">
                <p class="pt-0 pb-0 mb-2">
                  {{ $t("admin.lblMeetingBasedRoleType") }}
                </p>
                <meeting-type-permission-list
                  v-model="meetingTypesData"
                  :isPhotoUploading="isPhotoUploading"
                ></meeting-type-permission-list>
              </v-col>
            </v-row>
            <small>{{ $t("admin.txtReqField") }}</small>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              color="primaryDark"
              @click="SaveUser()"
              :disabled="
                !valid || !isEmailvalidate || !isDirtyData || !isPhotoUploading
              "
              >{{ $t("btnSave") }}</a-btn
            >
          </template>
          <span>{{ $t("btnSave") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              class="ml-2"
              color="secondary"
              @click="close()"
              >{{ $t("btnClose") }}</a-btn
            >
          </template>
          <span>{{ $t("btnClose") }}</span>
        </v-tooltip>
      </v-card-actions>
      <MessageSheet
        :showMessage="displayMessage"
        :message="message"
        :messageType="messageType"
        @close="displayMessage = false"
      ></MessageSheet>
      <prevent-confirmation
        :prevent="isPrevent"
        @save="SaveUser"
        @discard="preventClose(true)"
        @cancel="preventClose(false)"
      >
      </prevent-confirmation>
    </v-card>
  </a-dialog>
</template>

<script>
import Vue from "vue";
import { mapActions, mapState, mapGetters } from "vuex";
import { createUUID, base64ToFile } from "../../utils/util";
import RepeatEmailInput from "./RepeatEmailInput.vue";
import ProfilePhoto from "./ProfilePhoto.vue";
import _ from "lodash";
import ADialog from "../../wrapper-component/ADialog.vue";
import ABtn from "../../wrapper-component/ABtn.vue";
import Loader from "@/components/Loader.vue";
import MessageSheet from "@/components/MessageSheet.vue";
import peopleService from "../../api/peopleService";
import MeetingTypePermissionList from "./MeetingTypePermissionList.vue";
import PreventConfirmation from "../PreventConfirmation.vue";
Vue.prototype.$eventHub = new Vue();

export default {
  components: {
    RepeatEmailInput,
    ADialog,
    ABtn,
    Loader,
    MessageSheet,
    MeetingTypePermissionList,
    ProfilePhoto,
    PreventConfirmation,
  },
  name: "AddUser",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    data: Object,
    userEmails: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      cloneMeetingTypeData: [],
      meetingTypesData: [],
      isPhotoUploading: true,
      search: null,
      resultSearch: null,
      selectedEmail: this.data && this.data.id ? this.data : null,
      valid: false,
      isEmailvalidate: true,
      offsetTop: 0,
      isPeople: false,
      focus: null,
      displayMessage: false,
      message: "",
      messageType: "",
      isReadonly: false,
      isPrevent: false,
      comboboxAutoSuggest: "none",
      fNameAutoSuggest: "none",
      lNameAutoSuggest: "none",
      stringLength:40,
      emailContactListValidation: this.$t("admin.msgEmailUnique"),
      rules: [
        (v) => !!(v ? v.trim() : "") || this.$t("ruleMandatory"),
        (v) => /[a-zA-Z]/.test(v),
      ],
      emailRules: [
        (v) => !!(v && this.emailRequired(v)) || this.$t("ruleEmailReq"),
        (v) => !!(v && this.maxLength(v)) || this.$t("ruleEmailMaxLength"),
        (v) => !!(v && this.validEmail(v)) || this.$t("ruleEmailvalid"),
        (v) =>
          !(v && this.checkUniqueWithContact(v)) ||
          this.$t("admin.msgEmailUnique"),
        (v) => !!(v && this.checkUnique(v)) || this.emailContactListValidation,
      ],
      roleRules: [
        (v) => !!(v && v.length) || this.$t("admin.msgRoleRequired"),
        (v) => /[一-龠ぁ-ゔァ-ヴーa-zA-Zａ-ｚＡ-Ｚ々〆〤]/.test(v),
      ],
      userForm: {
        id: this.data?.id ?? null,
        tenantid: sessionStorage.getItem("tenantId"),
        firstName: this.data?.firstName ?? "",
        lastName: this.data?.lastName ?? "",
        registered_email: this.data?.registered_email ?? "",
        roles: this.data?.roles ?? [],
        meeting_type_roles: this.data?.meeting_type_roles ?? [],
        contactEmailIds:
          this.data && this.data.contactEmailIds
            ? this.data.contactEmailIds
            : [""],
        user_id: this.data?.user_id ?? null,
        profilePhoto: this.data?.profilePhoto ?? "",
      },
    };
  },
  mounted() {
    const comboElem = document.getElementById("searchComboBox");
    if (comboElem) {
      comboElem.setAttribute("autocomplete", "none");
    }
    const meetingTypeRoles = this.userForm.meeting_type_roles;
    this.meetingTypesData = this.meetingTypes.map((item) => {
      const meetingRole = meetingTypeRoles.find(
        (m) => m.meeting_type_id === item.id
      );
      let role_id = null;
      if (meetingRole) {
        role_id = meetingRole.role_id;
      }
      return {
        meeting_type_id: item.id,
        role_id,
      };
    });
  },
  created() {
    this.$eventHub.$on(
      "onCheckEmailAttendeesError",
      this.onCheckEmailAttendeesError
    );
  },
  beforeDestroy() {
    this.$eventHub.$off("onCheckEmailAttendeesError");
  },
  watch: {
    async selectedEmail(value) {
      try {
        if (value && typeof value === "string") {
          if (validateEmail(value)) {
            this.userForm.registered_email = value;
            const user = this.usersWithContactEmails.find(
              (elem) =>
                elem.registered_email &&
                elem.registered_email.toLowerCase().trim() ===
                  value.toLowerCase().trim()
            );
            if (user) {
              const cIds = user.contactEmailIds
                ? user.contactEmailIds.filter((email) => email !== value)
                : [""];
              this.userForm.firstName = user.firstName;
              this.userForm.lastName = user.lastName;
              this.userForm.id = user.id;
              this.userForm.title = user.title;
              this.userForm.user_id = user.user_id;
              this.userForm.contactEmailIds = cIds.length > 0 ? cIds : [""];
              this.userForm.roles = user.roles;
              this.userForm.meeting_type_roles = user.meeting_type_roles;
              this.userForm.profilePhoto = user.profilePhoto;
              this.isPeople = false;
            } else {
              const uData = await peopleService.check_email(value);
              if (uData.data && uData.data.id) {
                const peopleData = uData.data;
                this.userForm.id = peopleData.id;
                this.userForm.firstName = peopleData.firstName;
                this.userForm.lastName = peopleData.lastName;
                this.userForm.title = peopleData.title;
                this.userForm.display_email = peopleData.display_email;
                this.userForm.registered_email = this.selectedEmail;
                this.userForm.profilePhoto = peopleData.profilePhoto;
                this.userForm.contactEmailIds =
                  peopleData.contactEmailIds.filter(
                    (email) => email !== this.selectedEmail
                  );
                if (peopleData.roles && peopleData.roles.length > 0) {
                  this.userForm.roles = peopleData.roles;
                }
                this.userForm.is_deleted = false;
              } else {
                this.userForm.firstName = null;
                this.userForm.lastName = null;
                this.isAvantBoardUser = false;
                this.userForm.id = null;
                this.userForm.title = null;
                this.userForm.user_id = null;
                this.userForm.profilePhoto = "";
                this.userForm.roles = [];
                this.userForm.meeting_type_roles = [];
                this.userForm.contactEmailIds = [];
                this.isPeople = false;
                this.$refs.refUserForm.resetValidation();
              }
            }
          } else {
            this.selectedEmail = null;
            this.userForm.firstName = null;
            this.userForm.lastName = null;
            this.userForm.registered_email = null;
            this.userForm.id = null;
            this.userForm.user_id = null;
            this.userForm.title = null;
            this.isPeople = false;
            this.userForm.profilePhoto = "";
            this.$refs.refUserForm.resetValidation();
          }
        } else if (value && (value.registered_email || value.display_email)) {
          const vEmail = value.registered_email
            ? value.registered_email
            : value.display_email;
          const cIds = value.contactEmailIds
            ? value.contactEmailIds.filter((email) => email !== vEmail)
            : [""];
          this.userForm.id = value.id;
          this.userForm.firstName = value.firstName;
          this.userForm.lastName = value.lastName;
          this.userForm.registered_email = vEmail;
          this.userForm.title = value.title;
          this.userForm.user_id = value.user_id;
          this.userForm.profilePhoto = value.profilePhoto;
          (this.userForm.contactEmailIds = cIds.length > 0 ? cIds : [""]),
            (this.userForm.roles = value.roles),
            (this.isPeople = true);
        }
      } catch (error) {
          console.log(error, "add user")
      }
    },
    meetingTypesData(value) {
      this.userForm.meeting_type_roles = value;
      this.cloneMeetingTypeData = _.cloneDeep(value);
    },
  },
  computed: {
    ...mapState({
      roleList: (state) => state.admin.roleList,
      userList: (state) => state.people.userList,
    }),
    ...mapGetters({
      getAdminUserList: "people/getAdminUserList",
      getPeopleUserList: "people/getPeopleUserList",
      meetingTypes: "tenant/agendaMeetingTypes",
    }),
    roleListItems() {
      return this.roleList.filter((r) => r.role_type === "general");
    },
    isDirtyData() {
      const data = {
        id: this.data.id,
        tenantid: this.data.tenantid,
        firstName: this.data.firstName,
        lastName: this.data.lastName,
        registered_email: this.data.registered_email || "",
        roles: this.data.roles,
        contactEmailIds: this.data.contactEmailIds,
        user_id: this.data.user_id,
        meeting_type_roles: this.cloneMeetingTypeData,
        profilePhoto: this.data.profilePhoto ?? "",
      };
      const data2 = {
        id: this.userForm.id,
        tenantid: this.userForm.tenantid,
        firstName: this.userForm.firstName,
        lastName: this.userForm.lastName,
        registered_email: this.userForm.registered_email,
        roles: this.userForm.roles,
        contactEmailIds: this.userForm.contactEmailIds,
        user_id: this.userForm.user_id,
        meeting_type_roles: this.userForm.meeting_type_roles,
        profilePhoto: this.userForm.profilePhoto ?? "",
      };
      return JSON.stringify(data) !== JSON.stringify(data2);
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
    saveDisabled(val) {
      return !this.valid;
    },
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
    peoples() {
      return this.getPeopleUserList;
    },
    usersWithContactEmails() {
      const userEmails = [];
      this.userList.forEach((user) => {
        if (user.contactEmailIds && user.contactEmailIds.length > 0) {
          user.contactEmailIds.forEach((email) => {
            if (email) {
              const userData = {
                id: user.id,
                user_id: user.user_id,
                display_email: email,
                registered_email: email,
                people_display_email: user.display_email,
                firstName: user.firstName,
                lastName: user.lastName,
                contactEmailIds: user.contactEmailIds,
                roles: user.roles,
                meeting_type_roles: user.meeting_type_roles,
                is_registered_user: user.is_registered_user,
                is_listed_in_people: user.is_listed_in_people,
                profilePhoto: user.profilePhoto ?? "",
                title: user.title,
              };
              userEmails.push(userData);
            }
          });
        }
      });
      return userEmails;
    },
  },

  methods: {
    ...mapActions({
      createUser: "admin/createUser",
      getUserList: "admin/getUserList",
      updateUser: "admin/updateUser",
      updateCachedUser: "admin/updateCachedUser",
    }),
    photoUploading(val) {
      this.isPhotoUploading = val;
    },
    newEmailAdded(value) {
      if (value) {
        setTimeout(() => {
          this.scrollToTop();
        }, 0);
      }
    },
    onCheckEmailAttendeesError(data) {
      this.isEmailvalidate = true;
      if (
        data.isError === true ||
        (data.errorEmails && data.errorEmails.length > 0)
      ) {
        this.isEmailvalidate = false;
        if (data.error_message)
          this.showMessageSheet(data.error_message, "error");
      } else if (data.errorEmails && data.errorEmails.length == 0) {
        this.isEmailvalidate = true;
      }
    },
    scrollToTop() {
      document.getElementById("userRoleId").scrollIntoView({
        behavior: "instant",
        block: "center",
        inline: "nearest",
      });
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    changeSkills() {
      this.search = "";
    },
    focusEmail(e) {
      this.comboboxAutoSuggest = "on";
      this.scrolling(e.srcElement);
    },
    focusRoles(e) {
      this.scrolling(e.srcElement);
    },
    scrolling(element) {
      let dialogCardEl = document.getElementById("dialog-card-text");
      if (dialogCardEl) {
        dialogCardEl.addEventListener("scroll", (event) => {
          if (element.id === "searchComboBox") {
            this.$refs.combobox.isMenuActive = false;
          } else if (element.id === "userRoleId") {
            if (this.$refs.refRoles.$refs.input) {
              this.$refs.refRoles.isMenuActive = false;
            }
          }
        });
      }
    },
    close,
    closeAfterSave,
    SaveUser,
    updateUserDetails,
    addUser,
    reset,
    uniqueKey() {
      return createUUID();
    },
    preventClose(status) {
      this.isPrevent = false;
      if (status) {
        this.$emit("input", false);
        // this.isDirty = false;
      }
    },
    filter(item, queryText) {
      const hasValue = (val) => (val != null ? val : "");
      const query = hasValue(queryText);
      if (
        (item.firstName &&
          item.firstName
            .toLowerCase()
            .indexOf(query.toString().toLowerCase()) !== -1) ||
        (item.lastName &&
          item.lastName
            .toLowerCase()
            .indexOf(query.toString().toLowerCase()) !== -1) ||
        (item.contactEmailIds &&
          item.contactEmailIds.filter(
            (email) =>
              email &&
              email.toLowerCase().indexOf(query.toString().toLowerCase()) !== -1
          ).length > 0)
      ) {
        return true;
      }
      return false;
    },
    itemSelected(itemEmail) {
      return (
        this.selectedEmail &&
        this.selectedEmail.registered_email &&
        this.selectedEmail.registered_email == itemEmail
      );
    },
    itemSelectedGroup(id) {
      return (
        this.selectedEmail &&
        this.selectedEmail.id &&
        this.selectedEmail.id == id
      );
    },
    selectEmail(uid, emailId) {
      const userData = _.cloneDeep(this.userList);
      const result = userData.find((item) => item.id == uid);
      result.registered_email = emailId;
      this.selectedEmail = result;
      this.resultSearch = null;
      const searchEl = this.$refs.combobox;
      if (searchEl) {
        searchEl.isMenuActive = false;
      }
    },
    emailRequired(email) {
      if (email && typeof email === "string" && email != "") {
        return true;
      } else if (email && email.registered_email) {
        return true;
      } else {
        return true;
      }
    },
    maxLength(email) {
      if (email && typeof email === "string") {
        return email.length <= 70;
      } else if (email && email.registered_email) {
        return email.registered_email.length <= 70;
      } else {
        return true;
      }
    },
    validEmail(email) {
      if (email && typeof email === "string") {
        return this.checkValidEmail(email);
      } else if (email && email.registered_email) {
        return this.checkValidEmail(email.registered_email);
      } else {
        return true;
      }
    },
    checkValidEmail(sEmail) {
      const reEmail =
        /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
      if (!sEmail.match(reEmail)) {
        return false;
      }
      return true;
    },
    checkUnique(email) {
      this.emailContactListValidation = this.$t("admin.msgUserEmailUnique");
      const thiEmail =
        email && typeof email === "string"
          ? email
          : email && email.registered_email
          ? email.registered_email
          : email.display_email;
      if (thiEmail && thiEmail != "") {
        const updatedId = this.data && this.data.id ? this.data.id : null;
        const existIndex = this.userEmails.findIndex(
          (item) =>
            (item.registered_email == thiEmail.toLowerCase().trim() &&
              item.id != updatedId) ||
            (item.contactEmailIds.findIndex(
              (emailId) => emailId == thiEmail.toLowerCase().trim()
            ) >= 0 &&
              item.id != updatedId)
        );
        if (
          this.userForm.contactEmailIds.includes(thiEmail.toLowerCase().trim())
        ) {
          this.emailContactListValidation = this.$t("admin.msgUserEmailUnique");
          this.isReadonly = true;
          return false;
        }
        if (existIndex === -1) {
          this.isReadonly = false;
          return true;
        } else {
          if (
            this.userEmails[existIndex].registered_email &&
            this.userEmails[existIndex].registered_email !== thiEmail
          ) {
            this.emailContactListValidation = this.$t(
              "admin.msgUserContactEmailUnique",
              { user: this.userEmails[existIndex].registered_email }
            );
          }
          this.isReadonly = true;
          return false;
        }
      } else {
        this.isReadonly = false;
        return true;
      }
    },
    checkUniqueWithContact(email) {
      const thiEmail =
        email && typeof email === "string"
          ? email
          : email && email.registered_email
          ? email.registered_email
          : email.display_email;
      return !this.isEdit
        ? this.userForm.contactEmailIds.includes(thiEmail.toLowerCase().trim())
        : false;
    },
    filterKey(e) {
      const key = e.key;
      const specialChar = [
        "!",
        "@",
        "#",
        "$",
        "%",
        "^",
        "&",
        "*",
        "(",
        ")",
        "_",
        "=",
        "+",
        ",",
        "<",
        "?",
        "/",
        ">",
        ":",
        ";",
        '"',
      ];
      if (specialChar.includes(key)) return e.preventDefault();
    },
    onTypingEmail(isTyping) {
      this.isEmailvalidate = !isTyping;
    },
  },
};


const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};
function closeAfterSave() {
  this.reset();
  this.$emit("input", false);
}
async function SaveUser() {
  this.isPrevent = false;
  if (this.$refs.refUserForm.validate() && this.isEmailvalidate) {
    let response = {};
    const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
    const tenant = users.find((u) => u.id === this.tenantId);
    if (tenant) {
      this.userForm.tenantname = tenant.name;
    }

    this.userForm.contactEmailIds = _.compact(this.userForm.contactEmailIds);
    const cEmails = _.cloneDeep(this.userForm.contactEmailIds);
    cEmails.push(this.userForm.registered_email);
    const doesArrayHaveDuplicates = cEmails.some(
      (val, i) => cEmails.indexOf(val) !== i
    );
    if (doesArrayHaveDuplicates) {
      this.showMessageSheet(this.$t("admin.msgEmailDuplicate"), "info");
      return false;
    }
    this.userForm.is_registered_user = true;
    this.userForm.meeting_type_roles = this.meetingTypesData;
    if (this.userForm.id) {
      response = await this.updateUserDetails();
    } else {
      response = await this.addUser();
    }
    if (response.status == true) {
      this.$emit("saveUser");
      this.closeAfterSave();
    }
  }
}

async function addUser() {
  this.userForm.id = createUUID();

  let userData = _.cloneDeep(this.userForm);
  const existIndex = userData.contactEmailIds.findIndex(
    (item) => item == userData.registered_email
  );
  if (existIndex === -1 && userData.registered_email) {
    userData.contactEmailIds.push(userData.registered_email);
  }
  let res = { status: false };

  let formData = new FormData();
  if (!userData.profilePhoto) {
    formData.append("profilePhoto", ""); // append files or other data
  } else {
    const existingPhoto = base64ToFile(userData.profilePhoto);
    formData.append("profilePhoto", existingPhoto); // append files or other data
  }

  delete userData.profilePhoto;
  formData.append("userData", JSON.stringify(userData));

  await this.createUser(formData)
    .then((r) => {
      res = { status: true };
    })
    .catch((e) => {
      res = { status: false };
      this.userForm.id = null;
    });

  return res;
}

async function updateUserDetails() {
  let userData = _.cloneDeep(this.userForm);
  const existIndex = userData.contactEmailIds.findIndex(
    (item) => item == userData.registered_email
  );
  if (existIndex === -1 && userData.registered_email) {
    userData.contactEmailIds.push(userData.registered_email);
  }
  let res = { status: false };

  let formData = new FormData();
  if (!userData.profilePhoto) {
    formData.append("profilePhoto", ""); // append files or other data
  } else {
    const existingPhoto = base64ToFile(userData.profilePhoto);
    formData.append("profilePhoto", existingPhoto); // append files or other data
  }

  delete userData.profilePhoto;
  formData.append("userData", JSON.stringify(userData));

  await this.updateUser(formData)
    .then((r) => {
      res = { status: true };
    })
    .catch((e) => {
      res = { status: false };
    });

  return res;
}

function close() {
  if (this.isDirtyData) {
    this.isPrevent = true;
  } else {
    this.reset();
    this.$emit("input", false);
  }
}

function reset() {
  this.$nextTick(() => {
    this.$refs.refUserForm?.resetValidation();
    this.$refs.refUserForm?.reset();
  });
}
</script>

<style scoped>
.userListItem{
  border: solid 1px rgba(0, 0, 0, 0.12); 
  margin-right: 5px; 
  max-width: 500px;
}

.textField {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  min-height: 48px !important;
  max-height: 68px !important;
  color: var(--v-neutralGray-base) !important;
  align-items: center !important;
}
.textField /deep/ .v-input__slot {
  min-height: 48px !important;
  color: var(--v-neutralGray-base) !important;
}
.searchComboBox /deep/ .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
  height: 70px !important;
}
.user-combo-selection {
  background-color: #f4f4f4 !important;
  position: absolute;
  width: 93%;
  z-index: 9999999;
  top: 102px;
}
.bg-divider /deep/ .v-list-group__items {
  background-color: #fafafa !important ;
}
</style>